import React, { useRef, useState } from 'react';
import Modal from 'react-modal';
import { useSelector } from 'react-redux';
import AdvForm from '../../CommonComponents/AdvForm';
import { Alert } from '../../CommonComponents/OPL/Alert/Alert';
import { Checkbox } from '../../CommonComponents/OPL/Checkbox/Checkbox';
import { selectHasFirmSettingsAccess } from '../../CommonSelectors/CommonAreaSelector';

const SaveModal = ({ modal_open, on_cancel, on_save, template_names }) => {
  const [error, setError] = useState(null);
  const [isFirmLevelTemplate, setIsFirmLevelTemplate] = useState(false);

  const nameInputRef = useRef();

  const hasFirmSettingsAccess = useSelector(selectHasFirmSettingsAccess);

  return (
    <Modal
      isOpen={modal_open}
      onRequestClose={on_cancel}
      shouldCloseOnOverlayClick={false}
      className="popup save-template"
      overlayClassName="closerdiv"
    >
      <h2 className="title">
        Save Template As
        <i onClick={on_cancel} className="fa fa-times close" />
      </h2>
      <AdvForm>
        {error && <Alert variant="error" message={error} mb="24" />}

        <ul className="vertical-layout">
          <li>
            <label>Template Name</label>
            <div className="input">
              <input type="text" className="md" id="template_name" ref={nameInputRef} />
            </div>
          </li>

          {hasFirmSettingsAccess && (
            <li style={{ paddingLeft: 200 }}>
              <Checkbox
                checked={isFirmLevelTemplate}
                onChange={evt => setIsFirmLevelTemplate(evt.target.checked)}
                helperText="Firm-level templates will be visible by all of the firm's advisors."
              >
                Firm-Level Template
              </Checkbox>
            </li>
          )}
        </ul>
      </AdvForm>

      <div className="actions">
        <button
          onClick={() => {
            const value = nameInputRef.current.value.toLowerCase().trim();

            if (nameInputRef.current.value.trim() === '') {
              setError('Template name cannot be empty');
              return;
            }

            if (template_names.find(({ label }) => label.toLowerCase().trim() === value)) {
              setError('Template name already exists');
              return;
            }

            on_save(isFirmLevelTemplate);
          }}
          className="green rhs"
          id="btn-save"
        >
          Save Changes
        </button>
        <button onClick={on_cancel} className="secondary dismiss lhs" id="btn-cancel">
          Cancel
        </button>
      </div>
    </Modal>
  );
};

export default SaveModal;
